<ul class="dropdown-menu">
    <div *ngFor="let option of options">
        <a (click)="setOptionSelected(option)" class="dropdown-item" style="cursor:pointer" >
            <i class={{option.icon}} style="margin-right: 10%;"></i>
            {{option.name}}
        </a>
    </div>
</ul>